import { parseTaggedJsonMessage } from "./generalHelpers";
import { getAuth } from "firebase/auth";

const TTS_EVAL_API_URL = "https://tts-eval-api-554232563465.us-west1.run.app";
const PIPELINE_API_URL = "https://gemini-tts-api-554232563465.us-west1.run.app/run-pipeline";

export const triggerTtsEvalRun = async (params) => {
  const response = await fetch(`${TTS_EVAL_API_URL}/run`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      podcast_id: params.podcast_id,
      node_id: params.node_id,
      language: params.language ?? "EN",
      ...(params.audioId ? { audioId: params.audioId } : {}),
      ...(params.audioPath ? { audioPath: params.audioPath } : {}),
      ...(params.bucket_name ? { bucket_name: params.bucket_name } : {}),
    }),
  });

  const data = await response.json().catch(() => null);

  if (!response.ok) {
    throw new Error(data?.detail || `TTS eval failed: ${response.status}`);
  }

  return data;
};

export const callGetIntent = async (message, currentState) => {
    try {
      // Define the URL of your deployed Cloud Function (update with your actual endpoint)
      const url = "https://us-central1-wui-go-97d87.cloudfunctions.net/get_intent"; // Update with your Cloud Function URL
  
      // Prepare the input for the request
      const data = {
        input: `
          Current input state: ${JSON.stringify(currentState, null, 2)}
          
          Request from user: ${message}
          
          Please make changes to input based on request and return only the final json of the updated input. I don't need any explanation.
        `,
      };
  
      // Make the POST request to the cloud function
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
  
      // Check if the response is OK (status code 200-299)
      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }
  
      // Parse the response JSON
      const responseData = await response.json();
  
      // Log the result to the console
      console.log("Cloud Function Response:", responseData);
  
      // Return the JSON response for further processing
      return responseData;
  
    } catch (error) {
      console.error("Error calling cloud function:", error);
      return {}; // Return an empty object in case of an error
    }
  };

  export const callProcessInstruction = async (message) => {
    try {
      // Define the URL of your deployed Cloud Function (update with your actual endpoint)
      const url = "https://us-central1-wui-go-97d87.cloudfunctions.net/process_instruction"; // Update with your Cloud Function URL
  
      // Prepare the input for the request
      const data = {
        instruction: message, // Pass the message as the instruction
      };
  
      // Make the POST request to the cloud function
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
  
      // Check if the response is OK (status code 200-299)
      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }
  
      // Parse the response JSON
      const responseData = await response.json();
  
      // Log the result to the console
      // console.log("Cloud Function Response:", responseData);
  
      // Return the JSON response for further processing
      return responseData;
  
    } catch (error) {
      console.error("Error calling cloud function:", error);
      return {}; // Return an empty object in case of an error
    }
  };

  export const getScaledOutQuestions = async (originalQuestion, newRequest) => {
    const url =
      "https://us-central1-wui-go-97d87.cloudfunctions.net/scale_out_expand_questions";
  
    const data = {
      original_question: originalQuestion,
      new_request: newRequest,
    };
  
    console.log("Scale-out request payload:", data);
  
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
  
      const result = await response.json();
  
      if (!result.message) {
        console.error("No 'message' field in response:", result);
        return { final_result: null };
      }
  
      const final_result = parseTaggedJsonMessage(result.message);
      if (!final_result) {
        console.error("Could not extract JSON from model output:", result.message);
        return { final_result: null };
      }
      return { final_result };
    } catch (error) {
      console.error("Error fetching scale-out questions:", error);
      return { final_result: null };
    }
  };

  export const getScaledOutQuestionConcise = async (originalQuestion, newRequest) => {
    const url =
      "https://us-central1-wui-go-97d87.cloudfunctions.net/scale_out_expand_questions_concise";

    const data = {
      original_question: originalQuestion,
      new_request: newRequest,
    };

    console.log("Concise scale-out request payload:", data);

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();

      console.log(result)

      if (!result.message) {
        console.error("No 'message' field in concise scale-out response:", result);
        return { final_result: null };
      }

      const final_result = parseTaggedJsonMessage(result.message);
      if (!final_result) {
        console.error("Could not extract JSON from concise model output:", result.message);
        return { final_result: null };
      }
      return { final_result };
    } catch (error) {
      console.error("Error fetching concise scale-out question:", error);
      return { final_result: null };
    }
  };


  export const getDetailedInstructions = async (message) => {
    const url = "https://us-central1-wui-go-97d87.cloudfunctions.net/analyze_traffic_instruction_steps"; // Replace with your actual Cloud Function URL
  
    try {
      // Prepare the request payload
      const data = { instruction: message };
  
      // Make a POST request to the Cloud Function
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
  
      // Parse the JSON response
      const result = await response.json();
  
      if (!response.ok) {
        throw new Error(result.error || "Something went wrong");
      }
  
      return result.steps; // Return the generated steps from the response
    } catch (error) {
      console.error("Error analyzing instruction:", error);
      return null; // Handle errors gracefully
    }
  };


  export const analyzeAndProcessInstruction= async (message) => {
    const url =
      "https://us-central1-wui-go-97d87.cloudfunctions.net/analyze_traffic_data"; // Cloud Function URL
  
    // Prepare the request payload
    const data = {
      instruction: message,
    };
  
    try {
      // Make the API call
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
  
      // Convert response to JSON
      const result = await response.json();
  
      // Extract 'graph_content' and 'code' from the response

      let graphContent = "{ }";
      if(result.graph_content){
        graphContent = result.graph_content;
      }
      const code = result.code;
      const code_output = result.result;

      // console.log(result)
      // console.log(graphContent)

      graphContent = graphContent.replace(/^```json\n/, "").replace(/\n```$/, "");

      // Parse the JSON string into a JavaScript object
      let graphData = JSON.parse(graphContent);
  
      // Return the extracted data
      return { graphData, code, code_output };
    } catch (error) {
      console.error("Error fetching data:", error);
      return { graphContent: null, code: null }; // Return null values in case of error
    }
  };


const normalizeSelectionIds = (ids) => {
  if (ids instanceof Set) return Array.from(ids);
  if (Array.isArray(ids)) return ids;
  return [];
};

const buildSelectionContextTags = (selectedLinkIds = [], selectedNodeIds = []) => {
  const normalizedLinkIds = normalizeSelectionIds(selectedLinkIds).filter(Boolean);
  const normalizedNodeIds = normalizeSelectionIds(selectedNodeIds).filter(Boolean);
  if (normalizedLinkIds.length === 0 && normalizedNodeIds.length === 0) return "";

  return (
    "\n<Selection_context>" +
    "\n<Selected_links>" + JSON.stringify(normalizedLinkIds) + "</Selected_links>" +
    "\n<Selected_nodes>" + JSON.stringify(normalizedNodeIds) + "</Selected_nodes>" +
    "\n</Selection_context>"
  );
};

const CODE_API_RETRY_STATUSES = new Set([429, 503, 504]);
const CODE_API_MAX_RETRIES = 3;
const CODE_API_BASE_RETRY_DELAY_MS = 5000;

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const parseRetryAfterMs = (retryAfterHeader) => {
  if (!retryAfterHeader) return null;

  const seconds = Number(retryAfterHeader);
  if (Number.isFinite(seconds) && seconds >= 0) {
    return Math.round(seconds * 1000);
  }

  const dateMs = Date.parse(retryAfterHeader);
  if (!Number.isNaN(dateMs)) {
    return Math.max(0, dateMs - Date.now());
  }

  return null;
};

const fetchCodeApiWithRetries = async (url, options, onRetry = null) => {
  let attempt = 0;

  while (true) {
    let response = null;
    try {
      response = await fetch(url, options);
    } catch (error) {
      const shouldRetry = attempt < CODE_API_MAX_RETRIES;
      if (!shouldRetry) {
        throw error;
      }

      const backoffMs = CODE_API_BASE_RETRY_DELAY_MS * Math.pow(2, attempt);
      if (typeof onRetry === "function") {
        onRetry({
          status: null,
          errorType: "network_error",
          retryCount: attempt + 1,
          maxRetries: CODE_API_MAX_RETRIES,
          nextAttemptNumber: attempt + 2,
          totalAttempts: CODE_API_MAX_RETRIES + 1,
          delayMs: backoffMs,
        });
      }

      await sleep(backoffMs);
      attempt += 1;
      continue;
    }

    const shouldRetry =
      CODE_API_RETRY_STATUSES.has(response.status) &&
      attempt < CODE_API_MAX_RETRIES;

    if (!shouldRetry) {
      return response;
    }

    const retryAfterMs = parseRetryAfterMs(response.headers?.get("Retry-After"));
    const backoffMs =
      retryAfterMs ?? CODE_API_BASE_RETRY_DELAY_MS * Math.pow(2, attempt);

    if (typeof onRetry === "function") {
      onRetry({
        status: response.status,
        retryCount: attempt + 1,
        maxRetries: CODE_API_MAX_RETRIES,
        nextAttemptNumber: attempt + 2,
        totalAttempts: CODE_API_MAX_RETRIES + 1,
        delayMs: backoffMs,
      });
    }

    await sleep(backoffMs);
    attempt += 1;
  }
};

export const analyzeCodeError = async (
  message,
  selectedSimulationId,
  blockId,
  oldCode,
  errorMessage,
  variablesText,
  selectedLinkIds = [],
  selectedNodeIds = [],
  onRetry = null
) => {
    
  const url =
  "https://us-central1-wui-go-97d87.cloudfunctions.net/analyze_code_error"; // Cloud Function URL

  const other_variables_text = "<Other_variables (use if helpful)>" + variablesText + "</Other_variables (use if helpful)>"
  const selectionContext = buildSelectionContextTags(selectedLinkIds, selectedNodeIds);
  
  // Prepare the request payload
  const data = {
    instruction: "<Instruction>" + message + "</Instruction>" + "\n" +other_variables_text + selectionContext,
    selectedSimulationId: selectedSimulationId,
    blockId: blockId,
    prevCode: oldCode,
    errorMessage: errorMessage
  };

  try {
    // Make the API call
    const response = await fetchCodeApiWithRetries(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }, onRetry);

    if (!response.ok) {
      throw new Error(`Request failed with status ${response.status}`);
    }

    // Convert response to JSON
    const result = await response.json();

    // Extract 'graph_content' and 'code' from the response

  
    const code = result.code;
    const code_output = result.code_output;

    // console.log(result)


    // Return the extracted data
    return { code, code_output };
  } catch (error) {
    console.error("Error fetching data:", error);
    return { code: null, code_output: null }; // Return null values in case of error
  }
};

const generateCodeForAnalysisAtUrl = async (
  url,
  message,
  selectedSimulationId,
  blockId,
  variablesText,
  selectedLinkIds = [],
  selectedNodeIds = [],
  onRetry = null,
  analysisAddress = "",
  blockMetadata = {}
) => {
  const other_variables_text = "<Other_variables (use if helpful)>" + variablesText + "</Other_variables (use if helpful)>"
  const selectionContext = buildSelectionContextTags(selectedLinkIds, selectedNodeIds);

  // Prepare the request payload
  const data = {
    instruction: "<Instruction>" + message + "</Instruction>" + "\n" +other_variables_text + selectionContext,
    selectedSimulationId: selectedSimulationId,
    blockId: blockId,
    ...(analysisAddress ? { analysisAddress } : {}),
    ...(blockMetadata?.userQuery != null ? { userQuery: blockMetadata.userQuery } : {}),
    ...(blockMetadata?.instructions != null ? { instructions: blockMetadata.instructions } : {}),
    selectedLinkIds: normalizeSelectionIds(selectedLinkIds).filter(Boolean),
    selectedNodeIds: normalizeSelectionIds(selectedNodeIds).filter(Boolean),
    ...(blockMetadata?.timestamp != null ? { timestamp: blockMetadata.timestamp } : {}),
  };

  try {
    // Make the API call
    const response = await fetchCodeApiWithRetries(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }, onRetry);

    if (!response.ok) {
      throw new Error(`Request failed with status ${response.status}`);
    }

    // Convert response to JSON
    const result = await response.json();

    // Extract 'graph_content' and 'code' from the response

  
    const code = result.code;
    const code_output = result.code_output;

    // console.log(result)


    // Return the extracted data
    return { code, code_output };
  } catch (error) {
    console.error("Error fetching data:", error);
    return { code: null, code_output: null }; // Return null values in case of error
  }
};

export const generateCodeForAnalysis = async (...args) =>
  generateCodeForAnalysisAtUrl(
    "https://wui-planner-api-554232563465.us-west1.run.app/generate_analysis_code",
    ...args
  );

export const generateCodeForAnalysisV2 = async (...args) => {
  const serviceUrl =
    "https://wui-planner-api-v2-554232563465.us-west1.run.app";

  return generateCodeForAnalysisAtUrl(
    `${serviceUrl}/generate_analysis_code_v2`,
    ...args
  );
};

export const generateCodeForSingleBlockScaleOut = async ({
  instruction,
  selectedSimulationId,
  blockId,
  analysisAddress,
  userQuery,
  instructions = "",
  selectedLinkIds = [],
  selectedNodeIds = [],
  timestamp = null,
  useV2 = false,
}, onRetry = null) => {
  const serviceUrl =
    "https://wui-planner-api-2-554232563465.us-west1.run.app";
  const url = useV2
    ? `${serviceUrl}/generate_analysis_code_job_v2`
    : `${serviceUrl}/generate_analysis_code_job`;

  const data = {
    instruction,
    selectedSimulationId,
    blockId: String(blockId),
    analysisAddress,
    userQuery,
    instructions,
    selectedLinkIds: normalizeSelectionIds(selectedLinkIds).filter(Boolean),
    selectedNodeIds: normalizeSelectionIds(selectedNodeIds).filter(Boolean),
    timestamp,
  };

  const response = await fetchCodeApiWithRetries(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  }, onRetry);

  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    const detail = typeof result?.detail === "string"
      ? result.detail
      : JSON.stringify(result?.detail || result);
    throw new Error(detail || `Analysis job request failed (${response.status})`);
  }

  return result;
};


export const generateCodeForAnalysisShow= async (message, selectedSimulationId, uploadPoint) => {
  const url =
    "https://us-central1-wui-go-97d87.cloudfunctions.net/generate_analysis_code_show"; // Cloud Function URL

  // Prepare the request payload
  const data = {
    instruction: message,
    selectedSimulationId: selectedSimulationId,
    uploadPoint: String(uploadPoint)
  };

  try {
    // Make the API call
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    console.log("Show data:", data)

    // Convert response to JSON
    const result = await response.json();

    console.log("Show result:", result)

    // Return the extracted data
    return { };
  } catch (error) {
    console.error("Error fetching data in show:", error);
    return { }; // Return null values in case of error
  }
};


export const generateMapOutput= async (message, codeOutput) => {
  const url =
    "https://us-central1-wui-go-97d87.cloudfunctions.net/generate_map_output"; // Cloud Function URL

  // Prepare the request payload
  const data = {
    instruction: message,
    code_output: codeOutput
  };

  try {
    // Make the API call
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    // Convert response to JSON
    const result = await response.json();

    // Extract 'graph_content' and 'code' from the response

  
    let graphContent = "{ }";
      if(result.graph_content){
        graphContent = result.graph_content;
      }

      // console.log(result)
      // console.log(graphContent)

      graphContent = graphContent.replace(/^```json\n/, "").replace(/\n```$/, "");

      // Parse the JSON string into a JavaScript object
      let graphData = JSON.parse(graphContent);
  
      // Return the extracted data
      return { graphData };
    } catch (error) {
      console.error("Error fetching data:", error);
      return { graphContent: null }; // Return null values in case of error
    }
};



export const generateGraphs = async (instruction, code_output) => {
  try {
      const response = await fetch("https://us-central1-wui-go-97d87.cloudfunctions.net/generate_graphs", {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
          },
          body: JSON.stringify({
              instruction,
              code_output,
          }),
      });

      if (!response.ok) {
          throw new Error("Failed to generate graphs");
      }

      const result = await response.json();

      // Extract and parse graph content from JSON
      let graphContent = result.graph_content;
      // console.log(graphContent)
      const jsonMatch = graphContent.match(/```json\n([\s\S]*?)\n```/);

      if (!jsonMatch) {
          throw new Error("Invalid graph content format");
      }

      const graphData = JSON.parse(jsonMatch[1]);

      return {
          graphData, // Parsed JSON object
      };
  } catch (error) {
      console.error("Error generating graphs:", error);
      return {
          graphData: null,
      };
  }
};


export const generateTextResponse = async (instruction, code_output) => {
  try {
      const response = await fetch("https://us-central1-wui-go-97d87.cloudfunctions.net/generate_text_output", {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
          },
          body: JSON.stringify({
              instruction,
              code_output,
          }),
      });

      if (!response.ok) {
          throw new Error("Failed to generate graphs");
      }

      const result = await response.json();

      // Extract and parse graph content from JSON
      let textResponse = result.text_output;
      console.log(textResponse)

      return {
        textResponse, // Parsed JSON object
      };
  } catch (error) {
      console.error("Error generating text response:", error);
      return {
        textResponse: null,
      };
  }
};


export const generateLatexResponse = async (latextInput) => {
  try {
      const response = await fetch("https://us-central1-wui-go-97d87.cloudfunctions.net/generate_latex_output", {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
          },
          body: JSON.stringify({
            "input": latextInput
          }),
      });

      if (!response.ok) {
          throw new Error("Failed to generate graphs");
      }

      const result = await response.json();

      // Extract and parse graph content from JSON
      let latexResponse = result.latex_content;
      console.log("Latex response", latexResponse)
      latexResponse = latexResponse.replace(/^```latex/, '') // Remove starting ```latex
      .replace(/```$/, '')      // Remove ending ```
      .trim();  

      return {
        latexResponse, // Parsed JSON object
      };
  } catch (error) {
      console.error("Error generating latextResponse response:", error);
      return {
        textResponse: null,
      };
  }
};


export const analyzeChat= async (message, model_context, prev_chats) => {
  const url =
    "https://us-central1-wui-go-97d87.cloudfunctions.net/general_user_chat"; // Cloud Function URL

  // Prepare the request payload
  const data = {
    instruction: message,
    model_context: model_context,
    prev_chats: "[" + prev_chats + "]"
  };

  console.log("New message:", data)

  try {
    // Make the API call
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    // console.log("New chat response:", response)

    // Convert response to JSON
    const result = await response.json();


    // console.log("New chat result:", result)

    const result_json = result.message.match(/```output_json_start([\s\S]*?)```output_json_end/)[1].trim();
    
    // console.log("New chat result_json_str:", result_json)

    let final_result = JSON.parse(result_json)
    // console.log("New chat result_json:", final_result)
    
    return { final_result };
  } catch (error) {
    console.error("Error fetching data:", error);
    return { final_result: null }; // Return null values in case of error
  }
};


export const generateGraphsV2 = async (instruction, code_output, generated_code) => {
  try {
    const response = await fetch(
      "https://us-central1-wui-go-97d87.cloudfunctions.net/generate_graphs_V2",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          instruction,
          code_output,
          generated_code,
        }),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to generate graphs");
    }

    const result = await response.json();

    let graphContent = result.visual_output;
    console.log("Graph V2 content", graphContent);

    let parsedGraphContent = JSON.parse(graphContent);
    let graphOutput = parsedGraphContent["graph_output"];

    if (typeof graphOutput === "string") {
      try {
        graphOutput = JSON.parse(graphOutput);
      } catch (e) {
        console.error("Error parsing graph_output:", e);
      }
    }

    return {
      graphData: graphOutput,
      graphCode: result.code || null,
    };
  } catch (error) {
    console.error("Error generating graphs:", error);
    return {
      graphData: null,
      graphCode: null,
    };
  }
};


export const generateMapOutputV2 = async (instruction, code_output, generated_code) => {
  try {
      const response = await fetch("https://us-central1-wui-go-97d87.cloudfunctions.net/generate_map_output_V2", {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
          },
          body: JSON.stringify({
              instruction,
              code_output,
              generated_code
          }),
      });

      if (!response.ok) {
          throw new Error("Failed to generate map");
      }

      const result = await response.json();

      // Extract and parse graph content from JSON
      let graphContent = result.visual_output;
      console.log("Map V2 content", graphContent)

      let parsedGraphContent = JSON.parse(graphContent);
      let graphOutput = parsedGraphContent['map_output'];

      // If graphOutput is a string, attempt to parse it as JSON
      if (typeof graphOutput === "string") {
        try {
          graphOutput = JSON.parse(graphOutput);
        } catch (e) {
          // If parsing fails, it might not be a JSON string. You can handle this error as needed.
          console.error("Error parsing map_output:", e);
        }
      }

      return {
        graphData: graphOutput, // Parsed JSON object
      };
  } catch (error) {
      console.error("Error generating map:", error);
      return {
        graphData: null,
      };
  }
};


export const generatePodcastScript = async (podcastContent, language, uploadPoint) => {
  const url =
    "https://us-central1-wui-go-97d87.cloudfunctions.net/generate_podcast_script"; // Cloud Function URL

  // Prepare the request payload
  const data = {
    podcastData: podcastContent,
    lang: language,
    uploadPoint: uploadPoint
  };

  try {
    // Make the API call
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    console.log("Show data:", data)

    // Convert response to JSON
    const result = await response.json();

    console.log("Show result:", result)

    // Return the extracted data
    return { };
  } catch (error) {
    console.error("Error fetching data in show:", error);
    return { }; // Return null values in case of error
  }
};


export const getPathTimes = async (pathLinks, startTime, simulation_id, isInteractiveMap) => {
  const url =
    "https://us-central1-wui-go-97d87.cloudfunctions.net/get_path_times"; // Cloud Function URL

  // Prepare the request payload
  const data = {
    links: pathLinks,
    start_time: startTime,
    simulation_id: simulation_id
  };

  if (isInteractiveMap) {
      data.version = 2;
  }

  try {
    // Make the API call with proper headers and JSON body.
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    console.log("Sending data:", data);

    if (!response.ok) {
      throw new Error(`HTTP error: ${response.status}`);
    }

    // Convert response to JSON
    const result = await response.json();
    console.log("Response result:", result);

    // Return the extracted data from the Cloud Function.
    return result;
  } catch (error) {
    console.error("Error fetching getPathTimes:", error);
    // Return null in case of error (or you can modify to return an error object)
    return null;
  }
};


export const getTravelExperienceEnglishSummary = async (
  experienceData,          // array from getTravelExperienceToDestinations
  selectedLocation,        // { lat, lng }
  startTime,               // seconds (numeric)
  uploadPoint              // unique key (Date.now())
) => {
  const url =
    "https://us-central1-wui-go-97d87.cloudfunctions.net/generate_evacuations_narrative";

  const payload = {
    experienceData,
    selectedLocation,
    startTime,
    lang: "EN",
    uploadPoint
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });

    // API just returns {status:"done"}; we don't need it for now
    return await response.json();
  } catch (err) {
    console.error("Error requesting narrative:", err);
    return null;
  }
};


export const geocodeAddress = async (address) => {
  const url =
    "https://us-central1-wui-go-97d87.cloudfunctions.net/get_coordinates_from_address_string";

  const payload = { address };                // matches CF expectation

  try {
    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body:   JSON.stringify(payload),
    });

    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.error || `HTTP ${res.status}`);
    }

    const { lat, lng } = await res.json();    // { lat: <float>, lng: <float> }
    console.log(lat, lng, address);
    return { lat, lng };
  } catch (e) {
    console.error("geocodeAddress error:", e);
    return { lat: null, lng: null };          // consistent, predictable shape
  }
};


export const cloudRunHello = async () => {
  const url = "https://hello-world-554232563465.us-west1.run.app/"; // <- your Cloud Run URL

  try {
    const res = await fetch(url, {
      method: "GET",
      mode: "cors",
      redirect: "follow",
      cache: "no-store",
    });

    if (!res.ok) {
      const txt = await res.text().catch(() => "");
      throw new Error(txt || `HTTP ${res.status}`);
    }

    const text = await res.text(); // "Hello world!"
    return { ok: true, text };
  } catch (e) {
    console.error("cloudRunHello error:", e);
    return { ok: false, text: null };
  }
};


export const cloudRunRunGraph = async ({
  model_id = "simulation_4",
  prefix = "berkeley",
  blockId = "test_1",
  coords, // required: [[lon,lat], [lon,lat], [lon,lat], ...]
}) => {

  const baseUrl = "https://run-graph-554232563465.us-west1.run.app";
  const url = `${baseUrl.replace(/\/$/, "")}/run/graph`;

  try {
    const res = await fetch(url, {
      method: "POST",
      mode: "cors",
      redirect: "follow",
      cache: "no-store",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ model_id, prefix, blockId, coords }),
    });

    // Cloud Run sometimes returns text/html or text/plain on 503; handle both
    const contentType = res.headers.get("content-type") || "";
    const payloadText = await res.text().catch(() => "");

    if (!res.ok) {
      // Try to parse JSON error if it is JSON
      if (contentType.includes("application/json")) {
        try {
          const j = JSON.parse(payloadText);
          throw new Error(j.error || JSON.stringify(j));
        } catch {
          throw new Error(payloadText || `HTTP ${res.status}`);
        }
      }
      throw new Error(payloadText || `HTTP ${res.status}`);
    }

    // Parse JSON success if possible
    if (contentType.includes("application/json")) {
      const data = payloadText ? JSON.parse(payloadText) : {};
      return { ok: true, data };
    }

    // Fallback (shouldn’t happen if your Flask returns jsonify)
    return { ok: true, data: payloadText };
  } catch (e) {
    console.error("cloudRunRunGraph error:", e);
    return { ok: false, data: null, error: String(e?.message || e) };
  }
};

const OSM_NETWORK_API_URL =
  process.env.REACT_APP_OSM_NETWORK_API_URL ||
  "https://osm-network-api-554232563465.us-west1.run.app";

export const cloudRunBuildOsmNetwork = async ({
  simulationId,
  layerId = "links_default",
  layerName = "Links (default)",
  runId,
  blockId = runId,
  polygon,
}) => {
  const user = getAuth().currentUser;
  if (!user) {
    throw new Error("Sign in before generating an OSM road network.");
  }

  const firebaseToken = await user.getIdToken();
  const response = await fetch(
    `${OSM_NETWORK_API_URL.replace(/\/$/, "")}/v1/osm/network/build`,
    {
      method: "POST",
      mode: "cors",
      cache: "no-store",
      headers: {
        Authorization: `Bearer ${firebaseToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        simulationId,
        layerId,
        layerName,
        runId,
        blockId,
        polygon,
      }),
    }
  );

  const result = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(
      result?.error || result?.detail || `OSM network request failed (${response.status}).`
    );
  }

  return result;
};

export const cloudRunRunParcels = async ({
  model_id = "simulation_4",
  prefix = "berkeley",
  blockId = "test_2",
  coords, // required
}) => {
  
  const baseUrl = "https://run-parcel-554232563465.us-west1.run.app"
  const url = `${baseUrl.replace(/\/$/, "")}/run/parcels`;

  try {
    const res = await fetch(url, {
      method: "POST",
      mode: "cors",
      redirect: "follow",
      cache: "no-store",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ model_id, prefix, blockId, coords }),
    });

    const contentType = res.headers.get("content-type") || "";
    const payloadText = await res.text().catch(() => "");

    if (!res.ok) {
      if (contentType.includes("application/json")) {
        try {
          const j = JSON.parse(payloadText);
          throw new Error(j.error || JSON.stringify(j));
        } catch {
          throw new Error(payloadText || `HTTP ${res.status}`);
        }
      }
      throw new Error(payloadText || `HTTP ${res.status}`);
    }

    if (contentType.includes("application/json")) {
      const data = payloadText ? JSON.parse(payloadText) : {};
      return { ok: true, data };
    }

    return { ok: true, data: payloadText };
  } catch (e) {
    console.error("cloudRunRunParcels error:", e);
    return { ok: false, data: null, error: String(e?.message || e) };
  }
};

const BUILDER_LAYER_API =
  process.env.REACT_APP_BUILDER_LAYER_API_URL ||
  "https://builder-layer-api-5r2d6nagzq-uw.a.run.app";

export const refreshBuilderCriticalFacilities = async ({
  simulationId,
  layerId,
  blockId,
}) => {
  const response = await fetch(
    `${BUILDER_LAYER_API.replace(/\/$/, "")}/v1/builder/critical-facilities/refresh`,
    {
      method: "POST",
      mode: "cors",
      cache: "no-store",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        simulationId: String(simulationId || ""),
        layerId: String(layerId || ""),
        blockId: String(blockId || ""),
      }),
    }
  );

  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(result?.error || "Failed to submit critical-facilities job");
  }

  return result;
};

export const cloudRunStartPodcastTranscribe = async (
  podcastId,
  nodeId,
  selectedLanguage,
  { step = 0, runId } = {}
) => {
  const baseUrl = "https://podcast-generation-api-5r2d6nagzq-uw.a.run.app";
  const url = `${baseUrl.replace(/\/$/, "")}/podcast/transcribe/start`;

  try {
    const res = await fetch(url, {
      method: "POST",
      mode: "cors",
      cache: "no-store",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        podcastId,
        nodeId,
        selectedLanguage,
        runId,
        step,
      }),
    });

    const text = await res.text().catch(() => "");
    const ct = res.headers.get("content-type") || "";
    const data = ct.includes("application/json") ? (text ? JSON.parse(text) : {}) : text;

    if (!res.ok) {
      throw new Error((data && data.error) || text || `HTTP ${res.status}`);
    }

    return { ok: true, data };
  } catch (e) {
    console.error("cloudRunStartPodcastTranscribe error:", e);
    return { ok: false, error: String(e?.message || e), data: null };
  }
};

export const cloudRunStartGeneralModel = async (
  simulationId,
  runId,
  {
    runMetadataId = "",
    resultFirestorePath = "",
    vehiclesPerHousehold = 1,
    randomSeed = 42,
    routingStrat = "rerouting",
    linksFile = "berkeley_links.csv",
    nodesFile = "berkeley_nodes.csv",
    parcelsFile = "berkeley_parcels.csv",
    destinations = "destinations",
    departureTimes = "departure_times",
    criticalFacilities = "min",
    hazardId = null,
    hazardConfig = null,
    contraflowConfig = null,
    blockedRoadConfig = null,
  } = {}
) => {
  const baseUrl =
    process.env.REACT_APP_GENERAL_MODEL_API_URL ||
    "https://general-model-api-554232563465.us-west1.run.app";
  const url = `${baseUrl.replace(/\/$/, "")}/run`;

  try {
    const res = await fetch(url, {
      method: "POST",
      mode: "cors",
      cache: "no-store",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        simulation_id: simulationId,
        run_id: runId,
        run_metadata_id: String(runMetadataId || ""),
        result_firestore_path: String(resultFirestorePath || ""),
        vehicles_per_household: Number(vehiclesPerHousehold),
        random_seed: Number(randomSeed),
        routing_strat: String(routingStrat),
        links_file: String(linksFile),
        nodes_file: String(nodesFile),
        parcels_file: String(parcelsFile),
        destinations: String(destinations),
        departure_times: String(departureTimes),
        critical_facilities: String(criticalFacilities),
        hazard_id: hazardId == null || String(hazardId).trim() === "" ? null : String(hazardId),
        hazard_config:
          hazardConfig == null || String(hazardConfig).trim() === ""
            ? null
            : String(hazardConfig),
        contraflow_config:
          contraflowConfig == null || String(contraflowConfig).trim() === ""
            ? null
            : String(contraflowConfig),
        blocked_road_config: blockedRoadConfig == null || String(blockedRoadConfig).trim() === "" ? null : String(blockedRoadConfig),
      }),
    });

    const text = await res.text().catch(() => "");
    const ct = res.headers.get("content-type") || "";
    const data = ct.includes("application/json") ? (text ? JSON.parse(text) : {}) : text;

    if (!res.ok) {
      throw new Error((data && data.detail) || text || `HTTP ${res.status}`);
    }

    return { ok: true, data };
  } catch (e) {
    console.error("cloudRunStartGeneralModel error:", e);
    return { ok: false, error: String(e?.message || e), data: null };
  }
};

export const cloudRunFilterLayerByPolygons = async ({
  layer_type = "links", // "nodes" | "parcels" | "links"
  input_layer_gcs_uri, // required
  zones_gcs_uris, // required: string[]
  output_layer_gcs_uri, // required
  output_metadata_gcs_uri, // required
}) => {
  const baseUrl = "https://filter-layer-by-polygons-554232563465.us-west1.run.app";
  const url = `${baseUrl.replace(/\/$/, "")}/v1/builder/filter-layer-by-polygons`;

  try {
    const res = await fetch(url, {
      method: "POST",
      mode: "cors",
      redirect: "follow",
      cache: "no-store",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        layer_type,
        input_layer_gcs_uri,
        zones_gcs_uris,
        output_layer_gcs_uri,
        output_metadata_gcs_uri,
      }),
    });

    const contentType = res.headers.get("content-type") || "";
    const payloadText = await res.text().catch(() => "");

    if (!res.ok) {
      if (contentType.includes("application/json")) {
        try {
          const j = JSON.parse(payloadText);
          throw new Error(j.error || JSON.stringify(j));
        } catch {
          throw new Error(payloadText || `HTTP ${res.status}`);
        }
      }
      throw new Error(payloadText || `HTTP ${res.status}`);
    }

    if (contentType.includes("application/json")) {
      const data = payloadText ? JSON.parse(payloadText) : {};
      return { ok: true, data };
    }

    return { ok: true, data: payloadText };
  } catch (e) {
    console.error("cloudRunFilterLayerByPolygons error:", e);
    return { ok: false, data: null, error: String(e?.message || e) };
  }
};

export const runPodcastPipeline = async ({
  inputLocation,
  steps,
  outputFolder,
  statusFirestoreLocation,
}) => {
  const user = getAuth().currentUser;
  if (!user) throw new Error("User is not signed in.");

  const payload = {
    input_location: inputLocation,
    steps,
    output_folder: outputFolder,
    status_firestore_location: statusFirestoreLocation,
  };
  const missingFields = Object.entries(payload)
    .filter(([key, value]) => key === "steps"
      ? !Array.isArray(value) || value.length === 0
      : typeof value !== "string" || !value.trim())
    .map(([key]) => key);
  if (missingFields.length) {
    throw new Error(`Pipeline request is missing required fields: ${missingFields.join(", ")}.`);
  }

  const allowedSteps = ["generate", "polish", "audio"];
  const invalidSteps = steps.filter((step) => !allowedSteps.includes(step));
  if (invalidSteps.length) {
    throw new Error(`Pipeline request has invalid steps: ${invalidSteps.join(", ")}.`);
  }

  console.log("Pipeline request payload:", payload);
  const idToken = await user.getIdToken();
  const response = await fetch(PIPELINE_API_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify(payload),
  });

  const result = await response.json().catch(() => ({}));
  console.log("Pipeline response:", response.status, result);
  if (!response.ok) {
    const detail = typeof result.detail === "string"
      ? result.detail
      : JSON.stringify(result.detail || result);
    throw new Error(`Pipeline request failed (${response.status}): ${detail}`);
  }
  return result;
};
